import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const SearchCont = styled.div((props)=>({
  display:'flex',
  flexDirection:'column',

  // '.ui.input > input':{
  //   borderRadius:'3rem'
  // }
}))

export const DateCont = styled.div((props)=>({
  padding:'.67857143em 1rem',
  border:'1px solid rgba(34,36,38,.15)',
  borderRadius:'.28571429rem',
  marginLeft:'1rem',
  background:'#fff',
  display:'flex',
  justifyContent:'center',
  marginTop:'0.3rem',
  flex:'1'
}))

export const InputCont = styled.div((props)=>({
  display:'flex',
  alignItems:'baseline',
  
  '.searchInput':{
    flex:1,
    marginRight:'0.5rem'
  }
}))

export const AdvanceCont = styled.div((props)=>({
  display:'flex',
  justifyContent:'flex-start',
  alignItems:'flex-start',
  marginTop:'1rem',
  '.dropdown':{
    marginLeft:'0.5rem'
  },
  'div:first-child':{
    marginLeft:0
  }
}))

export const FiledRowContent = styled.div(()=>({
  // flex: 1,
  minWidth: '12rem',
  marginLeft:'0.5rem',

  '.field-label': {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: 5
  },

  '.error': {
    color: `${v.textError}`
  },

  '.warning': {
    color: 'orange'
  },

  '.field-input': {
    width: '100%'
  }

}))
